import React, { useState, useEffect, useRef, useMemo } from 'react';
import TextField from '@mui/material/TextField';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

import dayjs from 'dayjs';
import AccountCircle from '@mui/icons-material/AccountCircle';
import moment from 'moment';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputAdornment from '@mui/material/InputAdornment';
import Swal from 'sweetalert2';
import DescriptionIcon from '@mui/icons-material/Description';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EmailIcon from '@mui/icons-material/Email';
import ReceiptIcon from '@mui/icons-material/Receipt';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import api from '../utils/functions/api';
import TableInvoiceList from '../components/DetailMerchant/TableInvoiceList';
import Loading from '../components/Loading';
import '../custom.css';
import { Grid, Typography, Autocomplete } from '@mui/material'; // Responsive
import PlaceIcon from '@mui/icons-material/Place';
import AddHomeIcon from '@mui/icons-material/AddHome';
import axios from '../utils/functions/api';
import { useForm, Controller } from 'react-hook-form';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import LinearLoading from '../components/LinearLoading';

import { io } from 'socket.io-client';

import {
  initializeSocket,
  getSocket,
  disconnectSocket,
} from '../components/Socket/SocketComponent';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Disc } from 'react-feather';
import { swalErrorBtn, swalSuccessBtn } from '../helpers/swalHelper';
import InvoiceListApi from '../service/invoice.api';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Box from '@mui/material/Box';
import { Mail, MailOutline, MarkEmailRead } from '@mui/icons-material';
import { isEmpty } from 'lodash';

const textFieldStyles = {
  '& fieldset': {
    borderRadius: 30,
  },
  width: '100%',
};

function InvoiceList() {
  const [invoiceList, setInvoiceList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLinearLoading, setIsLinearLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [sort, setSort] = useState({ direction: '', column: null });
  const [openDialogInvoice, setOpenDialogInvoice] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDueDate, setSelectedDueDate] = useState(null);
  const [etaxStatus, setEtaxStatus] = useState(false);

  const [hasCustomExcel, setHasCustomExcel] = useState(true);
  const [havePdf, setHavePdf] = useState(false);
  const [NoQrCode, setNoQrCode] = useState(false);
  const [manualPayment, setManualPayment] = useState(false);

  const [filterMenuAnchorEl, setFilterMenuAnchorEl] = useState(null);
  const openFilterMenu = Boolean(filterMenuAnchorEl)

  const [sendMailOption, setSendMailOption] = useState({
    unsent: true,
    sent: true
  });

  const DATE_FORMAT = 'DD/MM/YYYY'

  const MAIL_STATUS = {
    'ALL': {
      text: 'ทั้งหมด',
      icon: ''
    },
    'UNSENT': {
      text: 'ที่ยังไม่ส่ง',
      icon: <MailOutline fontSize="small" className="mr-2" />
    },
    'SENT': {
      text: 'ที่ส่งแล้ว',
      icon: <MarkEmailRead fontSize="small" className="mr-2" />
    },
  }

  const socketRef = useRef(null);

  const schema = yup.object().shape({
    so_name: yup
      .string()
      .required('กรุณากรอกชื่อผู้ใช้บริการ')
      .matches(/^[^\s]/, 'ตัวแรกต้องไม่ใช่เว้นวรรค')
      .matches(
        /^[ก-๙a-zA-Z0-9\s]+$/,
        'กรอกได้เฉพาะตัวอักษรภาษาไทย ภาษาอังกฤษ และตัวเลขเท่านั้น',
      ),

    taxId:
      etaxStatus &&
      yup
        .string()
        .required('กรุณากรอกเลขประจำตัวผู้เสียภาษี')
        .matches(
          /^[0-9]{13}$/,
          'กรุณากรอกเลขประจำตัวผู้เสียภาษีให้ครบ 13 หลัก',
        ),

    invoice_no: yup
      .string()
      .required('กรุณากรอกเลขที่ใบแจ้งหนี้')
      .matches(
        /^[A-Za-z0-9]+$/,
        'กรุณากรอกเฉพาะตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น',
      ),

    descriptions: yup.string().required('กรุณากรอกรายละเอียดสินค้า บริการ'),

    email: yup
      .string()
      .nullable()
      .test(
        'is-valid-email-list',
        'กรุณากรอกอีเมลในรูปแบบที่ถูกต้อง (สามารถกรอกหลายอีเมลได้โดยใช้จุลภาคคั่น)',
        (value) => {
          // If etaxStatus is true, email is required
          if (etaxStatus && !value) {
            return false; // Email is required when etaxStatus is true
          }

          if (value) {
            const emails = value.split(',').map((email) => email.trim());
            const emailRegex =
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emails.every((email) => emailRegex.test(email));
          }

          return true; // If no email is provided, it's valid when etaxStatus is false
        },
      ),

    amount: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue.trim() === ''
          ? null
          : parseFloat(originalValue.replace(/,/g, ''));
      })
      .nullable()
      .required('กรุณากรอกจำนวนเงิน')
      .test(
        'is-decimal',
        'กรุณากรอกจำนวนเงินที่เป็นทศนิยมไม่เกิน 2 ตำแหน่ง',
        (value) => {
          return /^(\d+(\.\d{1,2})?)?$/.test(value);
        },
      ),

    address:
      etaxStatus &&
      yup
        .string()
        .required('กรุณากรอกที่อยู่')
        .matches(
          /^[^\u{1F600}-\u{1F64F}\u{2702}-\u{27B0}\u{1F680}-\u{1F6FF}\u{1F1E6}-\u{1F1FF}]*$/u,
          'กรุณากรอกที่อยู่ให้ถูกต้อง',
        ),

    zip_code:
      etaxStatus &&
      yup
        .string()
        .required('กรุณากรอกรหัสไปรษณีย์')
        .matches(/^[0-9]{5}$/, 'กรุณากรอกรหัสไปรษณีย์ให้ครบ 5 หลัก'),
    inv_start_date: yup.string().required('กรุณากรอกวันที่ใบแจ้งหนี้'),
    inv_due_date: yup.string().required('กรุณากรอกวันครบกำหนดชำระเงิน'),
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (item) => {
    // console.log('Form Data:', item);
    // console.log('Errors:', errors);
    try {
      const dataToSend = {
        ...item,
      };

      if (!item.email) {
        delete dataToSend.email;
      }

      // console.log('beforeSend', dataToSend);

      const resp = await InvoiceListApi.createInvoiceApi(item);
      // console.log('API Response:', resp);

      switch (resp.status_message) {
        case 'create success':
          swalSuccessBtn({title: 'สร้างรายการเสร็จสิ้น'}).then(async (result) => {
            setIsLoading(true);
            const data = await getInvoiceLists();
            if (data) {
              setIsLoading(false);
              handleClearFields();
            }
          });
          break;

        default:
          console.warn(
            'Unexpected status message:',
            resp.status_message,
          );
          break;
      }
    } catch (error) {
      console.error('Error occurred during POST request:', error);

      // Check if the error has a response
      if (error.response) {
        console.error('Error Response Data:', error.response.data);
        console.error('Error Response Status:', error.response.status);
        console.error('Error Response Headers:', error.response.headers);
      }
      swalErrorBtn({title: 'สร้างรายการหนี้ไม่สำเร็จ'});
    }
    setOpenDialogInvoice(false);
    // console.log('123', data);
  };

  // validation
  const [selectValue, setSelectValue] = React.useState(null);

  // const options = [];
  const [options, setOptions] = useState([]);

  const addOptions = async () => {
    const resp = await InvoiceListApi.getCustomerListApi();
    const results = resp.data;
    const etaxStatus = resp.etaxStatus;
    setEtaxStatus(etaxStatus);
    console.log('Etax Status:', etaxStatus);
    const labelOptions = results.map((item) => {
      const fullAddress = item.address
        ? `${item.address.address_detail || ''}, ตำบล${
            item.address.sub_district?.name || ''
          }, อำเภอ${item.address.district?.name || ''}, จังหวัด${
            item.address.province?.name || ''
          }`
        : '';

      return {
        label: `เลขภาษี: ${item.tax_id}, ชื่อ: ${item.name}, อีเมล: ${item.one_mail}`,
        value: {
          tax_id: item.tax_id || '',
          so_name: item.name,
          one_mail: item.one_mail,
          address: fullAddress || '',
          zip_code: item.address?.zip_code || '',
        },
      };
    });
    setOptions(labelOptions);
  };

  const handleChange = async (event, newValue) => {
    if (newValue) {
      setValue('taxId', newValue.value.tax_id);
      setValue('so_name', newValue.value.so_name);
      setValue('email', newValue.value.one_mail);
      setValue('address', newValue.value.address);
      setValue('zip_code', newValue.value.zip_code);
      console.log(newValue.value.one_mail);
    }
    //console.log('newValue', newValue);
    // setValue(newValue);
  };

  const handleClearFields = () => {
    reset();
    setSelectedDate(null);
    setSelectedDueDate(null);
  };

  const handleOpenDialogInvoice = async () => {
    await addOptions();
    setOpenDialogInvoice(true);
  };
  const handleCloseDialogInvoice = () => {
    setOpenDialogInvoice(false);
    handleClearFields();
  };

  const checkInvoiceLate = (data) => {
    let index = 0;
    data.forEach((item) => {
      const billDate = moment(item.inv_due_date).utc().endOf('day');
      const DateNow = moment().utc().startOf('day');
      if (billDate.isBefore(DateNow)) {
        data[index].isLate = false;
      } else {
        data[index].isLate = true;
      }
      index += 1;
    });
    setInvoiceList(data);
  };

  const getInvoiceLists = async () => {
    const start =
      startDate === null ? '' : dayjs(startDate).format('YYYYMMDDHHmmss');
    const end =
      endDate === null
        ? ''
        : dayjs(endDate).endOf('day').format('YYYYMMDDHHmmss');

    const sortBy = sort.column ? `${sort.column}:${sort.direction}` : '';
    try {
      setIsLinearLoading(true);
      const data = await InvoiceListApi.getInvoiceListApi(search, start, end, page, rowsPerPage, sortBy, sendMailOptionList);
      checkInvoiceLate(data[0].data);
      setTotal(
        data && data[0] && data[0].metadata[0] ? data[0].metadata[0].total : 0,
      );
      setHasCustomExcel(!!data[0].custom_excel?.has_custom_excel);
      setHavePdf(!!data[0].pdf?.have_pdf);
      setNoQrCode(!!data[0].no_qr);
      setManualPayment(!!data[0].allow_manual_payment);
      return data;
    } catch (e) {
      throw new Error(e);
    } finally {
      setIsLinearLoading(false);
    }
  };

  const onClickSearch = () => {
    getInvoiceLists();
  };
  const handleKeyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      getInvoiceLists();
    }
  };

  // Menu handle
  const onFilterButtonClick = (event) => {
    setFilterMenuAnchorEl(event.currentTarget);
  }

  const onCloseFiltterMenu = () => {
    setFilterMenuAnchorEl(null)
  }

  const onFilterChange = (event) => {
    setSendMailOption({
      ...sendMailOption,
      [event.target.name]: event.target.checked,
    })
  }

  const sendMailOptionList = useMemo(() => {
    return Object.keys(sendMailOption).filter(key => sendMailOption[key])
  }, [sendMailOption])

  const sendMailStatus = useMemo(() => {
    let status = ''

    if (sendMailOptionList.includes('unsent')) {
      status = 'UNSENT'
    }

    if (sendMailOptionList.includes('sent')) {
      status = 'SENT'
    }

    if (sendMailOptionList.length === 2) {
      status = 'ALL'
    }

    return MAIL_STATUS[status]
  }, [sendMailOption])

  useEffect(() => {
    getInvoiceLists();
    // searchData();
    return () => {};
  }, [rowsPerPage, page, sort]);

  useEffect(() => {
    const socket = initializeSocket();

    socket.on('paymentSuccess', (data) => {
      console.log('Payment Success Event:', data);

      // Call getInvoiceLists to refresh data
      getInvoiceLists();

      // Show Toast Notification
      toast.success(
        <div style={{ textAlign: 'left' }}>
          <p
            style={{
              margin: 0,
              fontWeight: 'bold',
              fontSize: '16px',
              color: '#333',
              whiteSpace: 'nowrap',
            }}
          >
            รายการ {data.invoiceNo}{' '}
            <span
              style={{
                fontWeight: 'normal',
                fontSize: '12px',
                color: '#777',
              }}
            >
              ชำระเงินเรียบร้อย
            </span>
          </p>
          <p style={{ margin: '4px 0', fontSize: '14px', color: '#555' }}>
            ฿{data.amount}{' '}
            <span style={{ fontSize: '12px', color: '#777' }}>
              - {new Date(data.paymentDate).toLocaleString()}
            </span>
          </p>
        </div>,
        {
          position: 'top-right',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        },
      );
    });

    return () => {
      // Remove event listener on unmount
      socket.off('paymentSuccess');
      disconnectSocket();
    };
  }, []);

  return (
    <div>
      <Loading isLoading={isLoading} />
      <div className="my-2 ml-2">
        <ToastContainer />
        <div className="text-lg font-light flex items-center">
          <div className="py-6 text-xl ">รายการใบแจ้งหนี้</div>
        </div>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="วันที่"
                  value={startDate}
                  inputFormat="DD/MM/YYYY"
                  maxDate={endDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={{ ...textFieldStyles }}
                      size="small"
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disabled={startDate === null || startDate === ''}
                    label="ถึง"
                    inputFormat="DD/MM/YYYY"
                    value={endDate}
                    minDate={startDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{ ...textFieldStyles }}
                        {...params}
                      />
                    )}
                  />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <Button
                variant="outlined"
                color="gray"
                sx={{
                  borderRadius: '20px',
                  width: '100%',
                  height: '100%',
                }}
                id="filter-menu-button"
                aria-controls={openFilterMenu ? 'filter-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openFilterMenu ? 'true' : undefined}
                onClick={onFilterButtonClick}
              >
                { !isEmpty(sendMailStatus?.icon) ? sendMailStatus.icon : <Mail fontSize="small" className="mr-2" /> }
                { !isEmpty(sendMailStatus?.text) ? `สถานะอีเมล ${sendMailStatus.text}` : 'เลือกสถานะอีเมล' }
              </Button>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Paper
                component="form"
                sx={{
                  pl: 2,
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '20px',
                  justifyContent: 'space-between',
                  boxShadow: 'none',
                  border: '1px solid #CCCCCC',
                }}
              >
                <InputBase
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  onKeyDown={handleKeyEnter}
                  fullWidth
                  placeholder="ค้นหา"
                />
                <div className="p-[8px]">
                  <SearchIcon
                    sx={{ fontSize: '22px', mr: 1, color: '#757575' }}
                  />
                </div>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6} lg={3} className="flex justify-between" >
              <Button
                variant="contained"
                sx={{
                  background: 'primary',
                  color: 'white',
                  borderRadius: '20px',
                }}
                onClick={() => {
                  onClickSearch();
                }}
              >
                ค้นหา
              </Button>
              {/* //สร้างรายการ  */}
              {!hasCustomExcel && (
                <Button
                  variant="contained"
                  sx={{
                    background: 'primary',
                    color: 'white',
                    borderRadius: '20px',
                  }}
                  onClick={() => {
                    handleOpenDialogInvoice();
                  }}
                >
                  สร้างรายการแจ้งหนี้
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>

      <Dialog
        open={openDialogInvoice}
        onClose={handleCloseDialogInvoice}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { minWidth: 'auto', maxWidth: 'auto' } }}
      >
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span>
              สร้างรายการใบแจ้งหนี้ <BorderColorIcon />
            </span>
            <span
              style={{
                color: 'red',
                fontSize: '0.8rem',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  fontSize: '1.5rem',
                  lineHeight: '1',
                  marginLeft: '4px',
                }}
              >
                *
              </span>
              จำเป็นต้องกรอก
            </span>
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Grid container spacing={2}>
                {options.length > 0 && (
                  <Grid item xs={12}>
                    <Autocomplete
                      disablePortal
                      id="searchable-dropdown"
                      options={options}
                      value={selectValue}
                      onChange={handleChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="รายชื่อลูกหนี้"
                          size="small"
                          variant="outlined"
                          fullWidth
                          sx={{
                            marginBottom: '1%',
                            marginTop: '5%',
                          }}
                        />
                      )}
                      sx={{ width: '100%' }}
                    />
                  </Grid>
                )}

                {etaxStatus && (
                  <Grid item xs={12} md={6} sx={{ marginTop: '5px' }}>
                    <TextField
                      fullWidth
                      {...register('taxId')}
                      error={!!errors.taxId}
                      helperText={errors.taxId?.message}
                      id="outlined-basic"
                      label={
                        <span>
                          เลขประจำตัวผู้เสียภาษี
                          <span style={{ color: 'red' }}> *</span>
                        </span>
                      }
                      variant="outlined"
                      placeholder="กรอกตัวเลข 13 หลัก"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <DescriptionIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                )}

                <Grid item xs={12} md={etaxStatus ? 6 : 12} sx={{ mt: 1 }}>
                  <TextField
                    fullWidth
                    onChange={handleChange}
                    {...register('so_name')}
                    error={!!errors.so_name}
                    helperText={errors.so_name?.message}
                    id="outlined-basic"
                    label={
                      <span>
                        ชื่อผู้ใช้บริการ
                        <span style={{ color: 'red', fontSize: '1.5rem' }}>
                          *
                        </span>
                      </span>
                    }
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {etaxStatus && (
                  <Grid item xs={12} md={8}>
                    <TextField
                      fullWidth
                      {...register('address')}
                      id="outlined-basic"
                      label={
                        <span>
                          ที่อยู่
                          <span style={{ color: 'red' }}> *</span>
                        </span>
                      }
                      variant="outlined"
                      error={!!errors.address}
                      helperText={errors.address?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AddHomeIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                )}

                {etaxStatus && (
                  <Grid item xs={12} md={4}>
                    <TextField
                      {...register('zip_code')}
                      fullWidth
                      id="outlined-basic"
                      label={
                        <span>
                          รหัสไปรษณีย์
                          <span style={{ color: 'red', fontSize: '1.5rem' }}>
                            *
                          </span>
                        </span>
                      }
                      variant="outlined"
                      error={!!errors.zip_code}
                      helperText={errors.zip_code?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PlaceIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                )}

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('invoice_no')}
                    error={!!errors.invoice_no}
                    helperText={errors.invoice_no?.message}
                    id="outlined-basic"
                    label={
                      <span>
                        เลขที่ใบแจ้งหนี้
                        <span style={{ color: 'red', fontSize: '1.5rem' }}>
                          *
                        </span>
                      </span>
                    }
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ReceiptIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('descriptions')}
                    error={!!errors.descriptions}
                    helperText={errors.descriptions?.message}
                    id="outlined-basic"
                    label={
                      <span>
                        รายละเอียด สินค้า บริการ
                        <span style={{ color: 'red', fontSize: '1.5rem' }}>
                          *
                        </span>
                      </span>
                    }
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ListAltIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('email')}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email?.message}
                    id="outlined-basic"
                    label="อีเมล"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                    placeholder="test@example.com"
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('amount')}
                    error={!!errors.amount}
                    helperText={errors.amount?.message}
                    id="outlined-basic"
                    label={
                      <span>
                        ยอดชำระ
                        <span style={{ color: 'red', fontSize: '1.5rem' }}>
                          *
                        </span>
                      </span>
                    }
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <span style={{ fontSize: '1.8rem' }}>฿</span>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <span style={{ fontSize: '0.8rem' }}>บาท</span>
                        </InputAdornment>
                      ),
                    }}
                    placeholder="THB"
                  />
                </Grid>

                <Grid item xs={12} md={6} sx={{ mt: 1 }}>
                  <div className="">
                    <span style={{ fontSize: '0.8rem' }}>
                      วันที่ใบแจ้งหนี้
                      <span style={{ color: 'red', fontSize: '1rem' }}>*</span>
                    </span>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={selectedDate ? dayjs(selectedDate, DATE_FORMAT) : null}
                        inputFormat={DATE_FORMAT}
                        onChange={(newValue) => {
                          setValue(
                            'inv_start_date',
                            newValue
                              ? dayjs(newValue).format(DATE_FORMAT)
                              : null,
                          );
                          setSelectedDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            sx={{ width: '100%' }}
                            error={!!errors.inv_start_date}
                            helperText={errors.inv_start_date?.message}
                            id="invoice-start-date"
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </Grid>

                <Grid item xs={12} md={6} sx={{ mt: 1 }}>
                  <div className="">
                    <span style={{ fontSize: '0.8rem' }}>
                      วันครบกำหนดชำระเงิน
                      <span style={{ color: 'red', fontSize: '1rem' }}>*</span>
                    </span>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={selectedDueDate ? dayjs(selectedDueDate, DATE_FORMAT) : null}
                        inputFormat={DATE_FORMAT}
                        minDate={selectedDate}
                        onChange={(newValue) => {
                          setValue(
                            'inv_due_date',
                            newValue
                              ? dayjs(newValue).format(DATE_FORMAT)
                              : null,
                          );
                          setSelectedDueDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            sx={{ width: '100%' }}
                            error={!!errors.inv_due_date}
                            helperText={errors.inv_due_date?.message}
                            id="invoice-due-date"
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <div className="flex justify-between px-4 pb-1">
            <DialogActions>
              <Button onClick={handleClearFields} color="error">
                Clear
              </Button>
            </DialogActions>
            <DialogActions>
              <Button
                onClick={handleCloseDialogInvoice}
                autoFocus
                color="error"
              >
                ยกเลิก
              </Button>
              <Button type="submit" variant="outlined">
                สร้างรายการ
              </Button>
            </DialogActions>
          </div>
        </form>
      </Dialog>

      <TableInvoiceList
        invoiceList={invoiceList}
        rowsPerPage={rowsPerPage}
        page={page}
        total={total}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        sort={sort}
        setSort={setSort}
        getInvoiceLists={getInvoiceLists}
        havePdf={havePdf}
        NoQrCode={NoQrCode}
        isLinearLoading={isLinearLoading}
        manualPayment={manualPayment}
      />

      <Menu
        id="filter-menu"
        anchorEl={filterMenuAnchorEl}
        open={openFilterMenu}
        onClose={onCloseFiltterMenu}
        slotProps={{
          list: {
            'aria-labelledby': 'filter-menu-button',
          },
        }}
      >
        <FormGroup>
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox checked={sendMailOption.unsent} onChange={onFilterChange} name="unsent" color="primary" />
              }
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  อีเมลที่ยังไม่ส่ง
                  <MailOutline fontSize="small" color="primary" />
                </Box>
              }
            />
          </MenuItem>
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox checked={sendMailOption.sent} onChange={onFilterChange} name="sent" color="primary" />
              }
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  อีเมลที่ส่งแล้ว
                  <MarkEmailRead fontSize="small" color="primary" />
                </Box>
              }
            />
          </MenuItem>
        </FormGroup>
      </Menu>
    </div>
  );
}

export default InvoiceList;
